// export this package's api
import Align from './Align';

export default Align;


//////////////////
// WEBPACK FOOTER
// ../rc-align/es/index.js
// module id = 1560
// module chunks = 25